import { cn } from "@/lib/utils";
import logoFull from "@/assets/hidnstock-logo.png";
import hsWhite from "@/assets/hs-logo-white.png";

interface TMVLogoProps {
  className?: string;
  variant?: "default" | "mark";
}

export const TMVLogo = ({ className, variant = "default" }: TMVLogoProps) => {
  if (variant === "mark") {
    return (
      <div className={cn("flex items-center justify-center", className)}>
        <div className="w-9 h-9 bg-foreground rounded-sm flex items-center justify-center">
          <img src={hsWhite} alt="HS" className="h-6 w-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="w-5 h-5 bg-foreground rounded-sm flex items-center justify-center flex-shrink-0">
        <img src={hsWhite} alt="HS" className="h-3 w-auto" />
      </div>
      <div className="h-20 flex items-center">
        <img src={logoFull} alt="HIDNstock - The B2B Remake Marketplace" className="h-full w-auto object-contain block" />
      </div>
    </div>
  );
};
